<div class="page-container">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="loading-content">
      <div class="spinner"></div>
      <h3>Loading Order Details...</h3>
      <p>Please wait while we fetch your order information</p>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="hasError && !isLoading" class="error-container">
    <div class="error-content">
      <div class="error-icon">
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="2"
          />
          <line
            x1="15"
            y1="9"
            x2="9"
            y2="15"
            stroke="currentColor"
            stroke-width="2"
          />
          <line
            x1="9"
            y1="9"
            x2="15"
            y2="15"
            stroke="currentColor"
            stroke-width="2"
          />
        </svg>
      </div>
      <h3>Error Loading Order Details</h3>
      <p>{{ errorMessage }}</p>
      <button class="btn btn-primary" (click)="loadOrderData()">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polyline
            points="23 4 23 10 17 10"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M20.49 15C19.9828 16.8399 18.8481 18.4187 17.2629 19.4985C15.6777 20.5783 13.7444 21.0879 11.7655 20.9468C9.78664 20.8057 7.93304 20.0217 6.53586 18.7124C5.13869 17.4031 4.28573 15.6413 4.12597 13.6769C3.9662 11.7125 4.51947 9.75379 5.69091 8.14665C6.86235 6.53951 8.58648 5.3896 10.5286 4.93003C12.4707 4.47046 14.5032 4.72916 16.2551 5.66407C18.007 6.59898 19.3749 8.14247 20.12 10"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        Retry
      </button>
    </div>
  </div>

  <!-- Main Content -->
  <div *ngIf="!isLoading && !hasError" class="content-wrapper">
    <!-- Header Section -->
    <div class="header-section">
      <div class="brand-header">
        <img
          src="assets/images/ui/logo.png"
          alt="Phlenu Delivery"
          class="brand-logo"
        />
      </div>

      <div class="page-title">
        <h2>Order Details</h2>
      </div>
    </div>

    <!-- Order Status Banner -->
    <div class="status-banner">
      <div class="status-indicator">
        <div class="status-icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>

    <!-- Order Details -->
    <div class="details-section">
      <h3>Order Information</h3>

      <div class="details-list">
        <div class="detail-item">
          <span class="label">Weight Class</span>
          <span class="value">{{ data.weightClass }}</span>
        </div>

        <div class="detail-item">
          <span class="label">Delivery Plan</span>
          <span class="value">{{ data.deliveryPlan }}</span>
        </div>

        <div class="detail-item">
          <span class="label">Package Content</span>
          <span class="value">{{ data.packageContent }}</span>
        </div>

        <div class="detail-item">
          <span class="label">Security Cover</span>
          <span class="value">{{ data.securityCover }}</span>
        </div>

        <div class="detail-item">
          <span class="label">Trust Check</span>
          <span class="value">{{ data.phlenuTrustCheck }}</span>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="footer-section">
      <div class="footer-content">
        <!-- Appreciation Message -->
        <div class="gratitude-message">
          <div class="gratitude-icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                fill="currentColor"
              />
            </svg>
          </div>
          <h4>Thank you for choosing Phlenu Delivery!</h4>
          <p>Your trust drives our commitment to excellence</p>
        </div>

        <!-- Quick Actions -->
        <div class="footer-actions">
          <a href="tel:+2348183919123" class="action-item">
            <div class="action-icon">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                  stroke="currentColor"
                  stroke-width="2"
                  fill="none"
                />
              </svg>
            </div>
            <div class="action-text">
              <span class="action-label">Need Help?</span>
              <span class="action-value">Support 24/7</span>
            </div>
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=com.phlenu.delivery"
            target="_blank"
            class="action-item"
          >
            <div class="action-icon">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <polygon
                  points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"
                  stroke="currentColor"
                  stroke-width="2"
                  fill="none"
                />
              </svg>
            </div>
            <div class="action-text">
              <span class="action-label">Rate Us</span>
              <span class="action-value">Share Feedback</span>
            </div>
          </a>
        </div>

        <!-- Brand Footer -->
        <div class="brand-footer">
          <div class="brand-tagline">
            <span>Delivered with</span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                fill="#ef4444"
              />
            </svg>
            <span>by Phlenu</span>
          </div>
          <div class="footer-version">
            <span> Secure. Reliable. Fast. Every Time.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
